module.exports = __webpack_public_path__ + "static/media/日营运车辆.ae162a9e.png";